import { http } from "./http";

export const loginApi = (payload) =>
  http.post("/auth/login", payload);

export const registerApi = (payload) =>
  http.post("/auth/signup", payload);

export const logoutApi = () =>
  http.post("/auth/logout");

export const forgotPasswordApi = (email) =>
  http.post("/auth/forgot-password", { email });

export const resetPasswordApi = (payload) =>
  http.post("/auth/reset-password", payload);
